// Test environment
export const environment = {
  apiBaseUrl: 'https://test-client-action.rkt.zone/external/client-uploads',
};
